import React, {Component} from 'react';
import classNames from 'classnames'
import TableData from '../../utils/tableUtil'
import * as formatter from "../../utils/formatters";

class PotentialBillingIncrease extends Component{

  constructor(props){
    super(props)
    this.state={data:this.props.data}
  }

  render(){
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let months = this.state.data.map( info => {
      return <TableData content={info.month}/>
    })

    let amount = this.state.data.map( info => {
      return <TableData content={formatter.formatNumber(info.amount)}/>
    })
    return (
      <table className={tableClass}>
        <thead>
        <tr>
          <th>Meses</th>
          {months}
        </tr>
        </thead>
        <tbody>
        <tr>
          <th scope="row">MDP</th>
          {amount}
        </tr>
        </tbody>
      </table>

    );

  }
}

export default PotentialBillingIncrease;



// WEBPACK FOOTER //
// ./src/components/tables/potentialBillingIncrease.js